export default __webpack_public_path__ + "static/media/to.03139515.jpg";